import React from 'react';
import * as styles from './styles.module.scss';

const Pattern = ({ className = '' }) => <div className={`${styles.pattern} ${className}`} />;

export default Pattern;
